import { Button, Popup } from '@quickmd-llc/design-system'
import {
  DELETE_A_USER_TEXT,
  DELETE_USER_POPUP_MESSAGE_TEXT,
  INTAKE_FORMS_CANCEL_BTN_TEXT,
} from '../../../utils/constants'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirmation popup for deleting a user (member). Replaces the legacy `ConfirmationPopup`
 * with the design-system `Popup` — primary/danger Delete button — mirroring
 * DeleteServiceTypePopup. Kept always-mounted (isOpen toggled) per the DS Popup contract.
 */
export const DeleteUserPopup = ({ isOpen, onClose, onConfirm }: Props) => (
  <Popup
    isOpen={isOpen}
    header={DELETE_A_USER_TEXT}
    body={<span>{DELETE_USER_POPUP_MESSAGE_TEXT}</span>}
    footer={
      <div className='flex justify-end gap-sp-1'>
        <Button priority='secondary' onClick={onClose}>
          {INTAKE_FORMS_CANCEL_BTN_TEXT}
        </Button>
        <Button priority='primary' theme='danger' onClick={onConfirm}>
          Delete
        </Button>
      </div>
    }
    onClose={onClose}
  />
)
